import { createContext } from 'react'

const SectionContext = createContext({ state: {}, actions: {} })

export default SectionContext
